import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { IPropertyEditor, PropertyEditor, PropertyEditorPropertyValues } from "../Controls/PropertyEditor";
import { NumericUpDown } from "./NumericUpDown";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorNumericUpDownPropertyValues =
    PropertyEditorPropertyValues
    & {
    };

export type PropertyEditorNumericUpDownProperties = {
    [name in keyof PropertyEditorNumericUpDownPropertyValues]: Property<PropertyEditorNumericUpDownPropertyValues[name]>
};

export interface IPropertyEditorNumericUpDown extends IPropertyEditor, PropertyEditorNumericUpDownProperties
{
}

export class PropertyEditorNumericUpDown extends PropertyEditor implements IPropertyEditorNumericUpDown
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorNumericUpDown";
    public static override className = "PropertyEditorNumericUpDown";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorNumericUpDownPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new NumericUpDown(),
            }
        };
    }

    // #endregion

    // #endregion
}
